import {PagingModel} from "../paging/PagingModel";
import {Asset} from "../../entities/Asset";
import {Location} from "../../entities/Location";
import {AssetService} from "../../services/AssetService";
import {LocationService} from "../../services/LocationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";

export class CheckoutModel extends PagingModel<Asset> {
    static $inject = ['$q','AssetService','LocationService','CustomFieldNameService','NotificationService'];
    selectedLocation:Location;
    selectedAsset:Asset;
    locations:Location[];
    checkOutTo:string;
    cmTest:string = "tester msg";
    errorMessage:string = "";
    constructor($q:ng.IQService,
                public pagingService:AssetService,
                public locationService:LocationService,
                public customFieldNameService:CustomFieldNameService,
                public notifyService:NotificationService) {
        super($q, pagingService,notifyService);
        this.locationService.getAll()
            .then((data)=>{
                this.locations = data;
            })
            .catch((exc)=>{
                this.notifyService.notify("Error in getting locations:"+exc);
            });
    }
    validate(checkingOut:boolean):boolean{
        this.errorMessage = "";
        if (checkingOut && (this.checkOutTo == null || this.checkOutTo.length == 0))
            this.errorMessage = "Please enter a user to check out to";
        return this.errorMessage.length == 0;
    }
    checkout(){
        if(this.validate(true)){
            var asset:Asset = this.selectedAsset;
            asset.checkedOutTo = this.checkOutTo;
            asset.checkinStatus = "Checked Out";
            var locationId = this.selectedLocation != null ? this.selectedLocation.id : null;
            //var changeLocationPromise = this.selectedLocation == null ? this.$q.when() : this.pagingService.updateLocation(asset.id,this.selectedLocation.id,true);
            this.$q.all([this.pagingService.updateCheckin(asset.id, locationId, "Checked Out", this.checkOutTo)])
                .then((data)=>{
                    this.notifyService.notify("Asset Updated Successfully");
                })
                .catch((exc)=>{
                    this.errorMessage = "Problem in Checking Out: "+exc;
                });
        }
    }
    checkin():void{
        if(this.validate(false)){
            var asset:Asset = this.selectedAsset;
            asset.checkedOutTo = this.checkOutTo;
            asset.checkinStatus = "Checked In";
            var locationId = this.selectedLocation != null ? this.selectedLocation.id : null;
            //var changeLocationPromise = this.selectedLocation == null ? this.$q.when() : this.pagingService.updateLocation(asset.id,this.selectedLocation.id,true);
            this.$q.all([this.pagingService.updateCheckin(asset.id,locationId, "Checked In", "")])
                .then((data)=>{
                    this.notifyService.notify("Asset Updated Successfully");
                })
                .catch((exc)=>{
                    this.errorMessage = "Problem in Checking In: "+exc;
                });
        }
    }
    selectionChanged():void{
        if(this.selectedItems.length > 0)
            this.selectedAsset = this.selectedItems[0];
        else
            this.selectedAsset = null;
        //alert("new sel changed asset null ?" +this.selectedAsset);
    }
    entityName():string{
        return "asset";
    }
    displayName():string{
        return "Assets";
    }
    transformItem(entity:Asset){
    }
    getColumnDefs():ng.IPromise<void>{
        return this.customFieldNameService.getAssetColumnDefs().then((data)=>{
            this.nameValuePairs = data;
        });
    }
}
